import Vue from 'vue';
import OwlCarousel from 'v-owl-carousel'

Vue.component('carousel', OwlCarousel);
Vue.component('realstate-about', require('../pages/about-us/RealState.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("realstate-about")) {
    new Vue({
        el: '#realstate-about',
    });
}